import { TerminatedEmployeeInput } from '../types';

export const getEmployeeSearchText = (
  employee: TerminatedEmployeeInput
): string =>
  [
    employee.socialSecurityNumber,
    employee.firstName,
    employee.lastName,
    `${employee.firstName} ${employee.lastName}`,
    employee.email,
    employee.phone,
  ]
    .join(' ')
    .toLowerCase();
